export const STORYLINE_TITLES = {
    1: 'AI Transformation Champion'
};

export const DEFAULT_TITLE = 'AI Transformation Champion';

export default {
    STORYLINE_TITLES,
    DEFAULT_TITLE
};
